import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../assets/Styles/CustomerManagementCSS/CustomerManagement.css';
import { 
  faSearch, 
  faFilter, 
  faPlus, 
  faHistory, 
  faChevronDown, 
  faTimes, 
  faCog,
  faChevronLeft,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import MultiSelectDropdown from '../../components/Controls/multiselectdropdown';

const CustomerSearch = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [quickFilters, setQuickFilters] = useState({
    phone: '',
    firstName: '',
    lastName: '',
    medId: ''
  });

  const dropdownpadding = {
    paddingLeft: '50px',
    height: "30px !important",
    borderRadius: "0px !important"
  };
  
  const [advancedFilters, setAdvancedFilters] = useState({
    dob: '',
    street: '',
    state: '',
    city: '',
    affiliate: 'CAT Paratransit',
    company: 'CAT',
    accounts: 'Not Specified',
    attributes: '',
    blackListed: 'All',
    active: true,
    onlySelected: false
  });

   const [familyMultiSelect, setFamilyMultiSelect] = useState({options: [], DropdownMode: 'rMS2', selectedValues:[], placeholder:"All Companies Selected", 
      displayValue:"name", emptyRecordMsg:"N/A", id:"CustomerSearchFamilySelect", className:"CustomerSearchFamilySelect toolbarGlobal text-nowrap", 
      SelectAllPlaceHolder:"All Companies Selected", AllItemsSelectedPlaceHolder:"All Companies Selected", styles:{width:"auto", marginLeft:"3px"}
    });

  const [activeFilterCount, setActiveFilterCount] = useState(1); // Active checkbox is checked by default

  const handleQuickFilterChange = (field, value) => {
    setQuickFilters(prev => ({ ...prev, [field]: value }));
  };

  const handleAdvancedFilterChange = (field, value) => {
    setAdvancedFilters(prev => ({ ...prev, [field]: value }));
  };

  const clearAllFilters = () => {
    setQuickFilters({ phone: '', firstName: '', lastName: '', medId: '' });
    setAdvancedFilters({
      dob: '', street: '', state: '', city: '', 
      affiliate: 'CAT Paratransit', company: 'CAT', 
      accounts: 'Not Specified', attributes: '', 
      blackListed: 'All', active: true, onlySelected: false
    });
    setActiveFilterCount(1);
  };

  function FamilySelectCallback(selectedvals) {

  };

  return (
    <div className="bg-white border-bottom shadow-sm">
      {/* Compact Header Row */}
      <div className="px-1 py-2">
        <div className="d-flex align-items-center justify-content-between gap-4">
          {/* Left: Quick Search Inputs */}
          <div className="d-flex align-items-center gap-3 flex-fill">
            <div className="d-flex align-items-center gap-2">
              <FontAwesomeIcon icon={faSearch} className="text-muted" style={{fontSize: '14px'}} />
            </div>
            
            <div className="d-flex align-items-center gap-2 flex-fill">
              <input
                type="tel"
                placeholder="Phone"
                value={quickFilters.phone}
                onChange={(e) => handleQuickFilterChange('phone', e.target.value)}
                className="form-control form-control-sm"
                style={{width: '80px', fontSize: '13px'}}
              />
              <input
                type="text"
                placeholder="First Name"
                value={quickFilters.firstName}
                onChange={(e) => handleQuickFilterChange('firstName', e.target.value)}
                className="form-control form-control-sm"
                style={{width: '100px', fontSize: '13px'}}
              />
              <input
                type="text"
                placeholder="Last Name"
                value={quickFilters.lastName}
                onChange={(e) => handleQuickFilterChange('lastName', e.target.value)}
                className="form-control form-control-sm"
                style={{width: '100px', fontSize: '13px'}}
              />
              <input
                type="text"
                placeholder="Med ID"
                value={quickFilters.medId}
                onChange={(e) => handleQuickFilterChange('medId', e.target.value)}
                className="form-control form-control-sm"
                style={{width: '80px', fontSize: '13px'}}
              />
              <MultiSelectDropdown options={familyMultiSelect} style={dropdownpadding} SelectionChangeCallback={FamilySelectCallback}/> 
            </div>
          </div>

          {/* Center: Quick Actions */}
          <div className="d-flex align-items-center gap-2">
            <button className="btn btn-primary btn-sm d-flex align-items-center gap-1" style={{fontSize: '13px'}}>
              <FontAwesomeIcon icon={faSearch} style={{fontSize: '12px'}} />
              Search
            </button>
            
            <button 
              onClick={() => setIsExpanded(!isExpanded)}
              className={`btn btn-sm d-flex align-items-center gap-1 ${
                activeFilterCount > 1 
                  ? 'btn-outline-warning border-warning' 
                  : 'btn-outline-secondary'
              }`}
              style={{fontSize: '13px'}}
            >
              <FontAwesomeIcon icon={faFilter} style={{fontSize: '12px'}} />
              <span>Filters</span>
              {activeFilterCount > 1 && (
                <span className="badge bg-warning text-dark rounded-pill ms-1" style={{fontSize: '10px', minWidth: '18px'}}>
                  {activeFilterCount}
                </span>
              )}
              <FontAwesomeIcon 
                icon={faChevronDown} 
                style={{
                  fontSize: '12px',
                  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease'
                }} 
              />
            </button>

            {activeFilterCount > 1 && (
              <button
                onClick={clearAllFilters}
                className="btn btn-link btn-sm text-muted p-1"
                style={{fontSize: '11px'}}
              >
                Clear All
              </button>
            )}
          </div>

          {/* Right: Action Buttons */}
          <div className="d-flex align-items-center gap-2">
            <button className="btn btn-success btn-sm d-flex align-items-center gap-1" style={{fontSize: '13px'}}>
              <FontAwesomeIcon icon={faPlus} style={{fontSize: '12px'}} />
              Add New
            </button>
            
            <div className="btn-group" role="group" style={{fontSize: '11px'}}>
              <button type="button" className="btn btn-outline-primary btn-sm active">
                Active
              </button>
              <button type="button" className="btn btn-outline-secondary btn-sm">
                In-Active
              </button>
              <button type="button" className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1">
                <FontAwesomeIcon icon={faCog} style={{fontSize: '10px'}} />
                Status
              </button>
            </div>
            
            <button className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1" style={{fontSize: '13px'}}>
              <FontAwesomeIcon icon={faHistory} style={{fontSize: '12px'}} />
              History
            </button>
          </div>
        </div>
      </div>

      {/* Expandable Advanced Filters */}
      {isExpanded && (
        <div className="px-4 pb-3 border-top bg-light">
          <div className="py-3">
            <div className="row g-3" style={{fontSize: '13px'}}>
              {/* Row 1 */}
              <div className="col-2">
                <label className="form-label" style={{fontSize: '11px', fontWeight: '600', color: '#6c757d'}}>DOB</label>
                <input
                  type="date"
                  value={advancedFilters.dob}
                  onChange={(e) => handleAdvancedFilterChange('dob', e.target.value)}
                  className="form-control form-control-sm"
                  style={{fontSize: '12px'}}
                />
              </div>
              
              <div className="col-2">
                <label className="form-label" style={{fontSize: '11px', fontWeight: '600', color: '#6c757d'}}>Street</label>
                <input
                  type="text"
                  placeholder="Street Address"
                  value={advancedFilters.street}
                  onChange={(e) => handleAdvancedFilterChange('street', e.target.value)}
                  className="form-control form-control-sm"
                  style={{fontSize: '12px'}}
                />
              </div>
              
              <div className="col-2">
                <label className="form-label" style={{fontSize: '11px', fontWeight: '600', color: '#6c757d'}}>State</label>
                <select
                  value={advancedFilters.state}
                  onChange={(e) => handleAdvancedFilterChange('state', e.target.value)}
                  className="form-select form-select-sm"
                  style={{fontSize: '12px'}}
                >
                  <option value="">All States</option>
                  <option value="CA">California</option>
                  <option value="GA">Georgia</option>
                  <option value="TX">Texas</option>
                </select>
              </div>
              
              <div className="col-2">
                <label className="form-label" style={{fontSize: '11px', fontWeight: '600', color: '#6c757d'}}>City</label>
                <select
                  value={advancedFilters.city}
                  onChange={(e) => handleAdvancedFilterChange('city', e.target.value)}
                  className="form-select form-select-sm"
                  style={{fontSize: '12px'}}
                >
                  <option value="">All Cities</option>
                  <option value="Savannah">Savannah</option>
                  <option value="Garden City">Garden City</option>
                  <option value="Germantown">Germantown</option>
                </select>
              </div>
              
              <div className="col-2">
                <label className="form-label" style={{fontSize: '11px', fontWeight: '600', color: '#6c757d'}}>Company</label>
                <select
                  value={advancedFilters.company}
                  onChange={(e) => handleAdvancedFilterChange('company', e.target.value)}
                  className="form-select form-select-sm"
                  style={{fontSize: '12px'}}
                >
                  <option value="CAT">CAT</option>
                  <option value="OTHER">Other</option>
                </select>
              </div>
              
              <div className="col-2">
                <label className="form-label" style={{fontSize: '11px', fontWeight: '600', color: '#6c757d'}}>Accounts</label>
                <select
                  value={advancedFilters.accounts}
                  onChange={(e) => handleAdvancedFilterChange('accounts', e.target.value)}
                  className="form-select form-select-sm"
                  style={{fontSize: '12px'}}
                >
                  <option value="Not Specified">Not Specified</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>
              </div>
            </div>
            
            {/* Row 2 - Checkboxes and remaining fields */}
            <div className="mt-3 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-4">
                <div className="form-check">
                  <input
                    type="checkbox"
                    checked={advancedFilters.active}
                    onChange={(e) => handleAdvancedFilterChange('active', e.target.checked)}
                    className="form-check-input"
                    id="activeCheck"
                  />
                  <label className="form-check-label" htmlFor="activeCheck" style={{fontSize: '12px'}}>
                    Active Only
                  </label>
                </div>
                
                <div className="form-check">
                  <input
                    type="checkbox"
                    checked={advancedFilters.onlySelected}
                    onChange={(e) => handleAdvancedFilterChange('onlySelected', e.target.checked)}
                    className="form-check-input"
                    id="selectedCheck"
                  />
                  <label className="form-check-label" htmlFor="selectedCheck" style={{fontSize: '12px'}}>
                    Only Selected Attributes
                  </label>
                </div>
                
                <div className="d-flex align-items-center gap-2">
                  <label className="form-label mb-0" style={{fontSize: '12px', color: '#6c757d'}}>Black Listed:</label>
                  <select
                    value={advancedFilters.blackListed}
                    onChange={(e) => handleAdvancedFilterChange('blackListed', e.target.value)}
                    className="form-select form-select-sm"
                    style={{width: 'auto', fontSize: '12px'}}
                  >
                    <option value="All">All</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
                
                {/* <div className="d-flex align-items-center gap-2">
                  <label className="form-label mb-0" style={{fontSize: '12px', color: '#6c757d'}}>Affiliate:</label>
                  <select
                    value={advancedFilters.affiliate}
                    onChange={(e) => handleAdvancedFilterChange('affiliate', e.target.value)}
                    className="form-select form-select-sm"
                    style={{width: 'auto', fontSize: '12px'}}
                  >
                    <option value="CAT Paratransit">CAT Paratransit</option>
                    <option value="Other">Other</option>
                  </select>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Results Summary Bar */}
      {/* <div className="px-4 py-2 bg-light border-top d-flex align-items-center justify-content-between" style={{fontSize: '12px', color: '#6c757d'}}>
        <div className="d-flex align-items-center gap-4">
          <span>Showing 1-50 of 1,120 customers</span>
          <div className="d-flex align-items-center gap-2">
            <span>Page:</span>
            <select className="form-select form-select-sm" style={{width: 'auto', fontSize: '12px'}}>
              <option>1</option>
              <option>2</option>
              <option>3</option>
            </select>
            <span>of 23</span>
            <button className="btn btn-sm btn-outline-secondary">
              <FontAwesomeIcon icon={faChevronLeft} style={{fontSize: '10px'}} />
            </button>
            <button className="btn btn-sm btn-outline-secondary">
              <FontAwesomeIcon icon={faChevronRight} style={{fontSize: '10px'}} />
            </button>
          </div>
        </div>
        
        <div className="d-flex align-items-center gap-2">
          <span>Show:</span>
          <select className="form-select form-select-sm" style={{width: 'auto', fontSize: '12px'}}>
            <option>50</option>
            <option>100</option>
            <option>200</option>
          </select>
          <span>per page</span>
        </div>
      </div> */}
    </div>
  );
};

export default CustomerSearch;